export default __webpack_public_path__ + "static/media/user-icon.271168c1.svg";